import { all } from 'redux-saga/effects'
import { favoriteSagas } from './favorite'
import { roomSagas } from './room'
import { userSagas } from './remote/user'
import { masterSagas } from './remote/master'
import { localRoomsSagas } from './local/rooms'
import { reservationSagas } from './reservation'
import { reservationDetailSagas } from './reservationDetail'
import { reservationReputationSagas } from './reservationReputation'
import { reservationEditSagas } from './reservationEdit'

export default function* rootSaga() {
  yield all([
    ...favoriteSagas,
    ...roomSagas,
    ...userSagas,
    ...masterSagas,
    ...localRoomsSagas,
    ...reservationSagas,
    ...reservationDetailSagas,
    ...reservationReputationSagas,
    ...reservationEditSagas,
  ])
}



// WEBPACK FOOTER //
// ./src/redux/modules/sagas.js